// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import PaymentProviderCaptureMethod from './logic'

export default function PaymentProviderCaptureMethodFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod">
      <PaymentProviderCaptureMethod {...props}>
        {children}
      </PaymentProviderCaptureMethod>
    </Flow>
  )
}
